import { ddsSpace } from "../../../design-tokens/meta";
import { publish } from "../../icc/broker";
import { isIE } from "../../utilities";

/**
 * Creates the event name that can be used with Custom Events (ddsCustomEvent)
 * @param {*} component
 * @param {*} event
 * @returns
 */
export const eventTemplate = (component, event) => {
    return `${ddsSpace}${component}${event}Event`;
};

/**
 * Each event in a single action will have states.
 * 1. Before: The action was created but is not in progress yet
 * 2. During: The action is in progress
 * 3. After: The action executed successfully
 */

// Web component specific
export const connected = (component) => {
    return eventTemplate(component, "Connected");
};

// Events for actions that Expand/Collapse
export const expand = (component) => {
    return eventTemplate(component, "Expand");
};
export const expanding = (component) => {
    return eventTemplate(component, "Expanding");
};
export const expanded = (component) => {
    return eventTemplate(component, "Expanded");
};
export const expandedAll = (component) => {
    return eventTemplate(component, "ExpandedAll");
};
export const collapse = (component) => {
    return eventTemplate(component, "Collapse");
};
export const collapsing = (component) => {
    return eventTemplate(component, "Collapsing");
};
export const collapsed = (component) => {
    return eventTemplate(component, "Collapsed");
};
export const collapsedAll = (component) => {
    return eventTemplate(component, "CollapsedAll");
};

// Events for actions that Open/Close
export const open = (component) => {
    return eventTemplate(component, "Open");
};
export const opening = (component) => {
    return eventTemplate(component, "Opening");
};
export const opened = (component) => {
    return eventTemplate(component, "Opened");
};
export const close = (component) => {
    return eventTemplate(component, "Close");
};
export const closing = (component) => {
    return eventTemplate(component, "Closing");
};
export const closed = (component) => {
    return eventTemplate(component, "Closed");
};

// Show Hide
export const show = (component) => {
    return eventTemplate(component, "Show");
};
export const showing = (component) => {
    return eventTemplate(component, "Showing");
};
export const shown = (component) => {
    return eventTemplate(component, "Shown");
};
export const hide = (component) => {
    return eventTemplate(component, "Hide");
};
export const hiding = (component) => {
    return eventTemplate(component, "Hiding");
};
export const hidden = (component) => {
    return eventTemplate(component, "Hidden");
};

// Error
export const failure = (component) => {
    return eventTemplate(component, "Failure");
};
export const success = (component) => {
    return eventTemplate(component, "Success");
};

// Summon Dismiss
export const summon = (component) => {
    return eventTemplate(component, "Summon");
};
export const summoned = (component) => {
    return eventTemplate(component, "Summoned");
};
export const dismiss = (component) => {
    return eventTemplate(component, "Dismiss");
};
export const dismissed = (component) => {
    return eventTemplate(component, "Dismissed");
};

// CRUD events
export const added = (component) => {
    return eventTemplate(component, "Added");
};
export const read = (component) => {
    return eventTemplate(component, "Read");
};
export const updated = (component) => {
    return eventTemplate(component, "Updated");
};
export const deleted = (component) => {
    return eventTemplate(component, "Deleted");
};

// Pagination
export const nextPageClicked = (component) => {
    return eventTemplate(component, "NextPageClicked");
};
export const previousPageClicked = (component) => {
    return eventTemplate(component, "PreviousPageClicked");
};
export const firstPageClicked = (component) => {
    return eventTemplate(component, "FirstPageClicked");
};
export const lastPageClicked = (component) => {
    return eventTemplate(component, "LastPageClicked");
};
export const pageSizeChanged = (component) => {
    return eventTemplate(component, "PageSizeChanged");
};
export const sort = (component) => {
    return eventTemplate(component, "Sort");
};
export const sorted = (component) => {
    return eventTemplate(component, "Sorted");
};
export const componentRender = (component) => {
    return eventTemplate(component, "ComponentRender");
};
export const componentRendered = (component) => {
    return eventTemplate(component, "ComponentRendered");
};
export const pageChange = (component) => {
    return eventTemplate(component, "PageChange");
};
export const pageChanged = (component) => {
    return eventTemplate(component, "PageChanged");
};

// Table events
export const pin = (component) => {
    return eventTemplate(component, "Pin");
};
export const unpin = (component) => {
    return eventTemplate(component, "Unpin");
};
export const scroll = (component) => {
    return eventTemplate(component, "Scroll");
};
export const headCellFocusChanged = (component) => {
    return eventTemplate(component, "FocusChanged");
};
export const styleUpdated = (component) => {
    return eventTemplate(component, "StyleUpdated");
};
export const resized = (component) => {
    return eventTemplate(component, "Resized");
};

// Events for actions that Select/Unselect
export const selectionChange = (component) => {
    return eventTemplate(component, "SelectionChange");
};

export default function dispatcher(eventName, related, details) {
    if (typeof eventName !== "string" || !related || typeof related.dispatchEvent !== "function") {
        console.warn("Unexpected args");
        return;
    }
    let evt;
    if (isIE) {
        evt = document.createEvent("CustomEvent");
        evt.initCustomEvent(eventName, true, true, details);
    } else {
        evt = new CustomEvent(eventName, {
            bubbles: true,
            composed: true,
            detail: details,
        });
    }
    evt.relatedTarget = related;
    related.id && publish(related.id, { type: eventName, details }, related);
    related.dispatchEvent(evt);
}
